/* ════════════════════════════════════════════════════════════
   KIDEO STORE — VERLANGLIJST
   Hartjes op productkaarten en de productpagina, teller in de
   header en de verlanglijst-pagina zelf. Opslag in localStorage
   (geen account nodig); de lijstpagina ververst prijs en
   voorraad live via /products/<handle>.js en gebruikt exact de
   productkaart-opmaak (.pkaart) van de rest van de winkel.
   ════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var SLEUTEL = 'kideo-verlanglijst';
  var ACCOUNT_SLEUTEL = 'kideo-verlanglijst-account'; // welk klant-id op dit apparaat al gesynct is

  var CART_SVG = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>';
  var KRUIS_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  /* ── Opslag ── */
  function lees() {
    try {
      var lijst = JSON.parse(localStorage.getItem(SLEUTEL) || '[]');
      return Array.isArray(lijst) ? lijst : [];
    } catch (e) { return []; }
  }
  function bewaarLokaal(lijst) {
    try { localStorage.setItem(SLEUTEL, JSON.stringify(lijst)); } catch (e) { /* privémodus */ }
    meldUpdate(lijst);
  }
  function schrijf(lijst) {
    bewaarLokaal(lijst);
    syncNaarServer();
  }

  /* ── Accountkoppeling: opslag in het Shopify-klantaccount via de App Proxy ──
     Alleen voor ingelogde klanten (window.KIDEO_KLANT is dan hun id); gasten
     blijven puur localStorage. De request loopt same-origin via /apps/verlanglijst,
     Shopify tekent hem en de backend beheert het customer-metafield. */
  function ingelogd() { return typeof window.KIDEO_KLANT === 'number'; }
  function api(method, body) {
    return fetch('/apps/proxy/verlanglijst', {
      method: method,
      headers: body ? { 'Content-Type': 'application/json' } : {},
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  var syncTimer = null;
  function syncNaarServer() {
    /* Alleen pushen als dit apparaat bevestigd met DÍT account is gesynct —
       nooit een (nog) niet-gekoppelde of andermans lijst naar een account duwen. */
    if (!ingelogd() || gesyncteKlant() !== String(window.KIDEO_KLANT)) return;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () { api('POST', { actie: 'set', items: lees() }); }, 800);
  }
  function gesyncteKlant() { try { return localStorage.getItem(ACCOUNT_SLEUTEL); } catch (e) { return null; } }
  function zetGesyncteKlant(id) { try { localStorage.setItem(ACCOUNT_SLEUTEL, String(id)); } catch (e) { /* privémodus */ } }

  /* Alleen http(s) of een pad toestaan — nooit javascript:/data: uit een
     opgeslagen waarde in een href/src laten belanden. */
  function veiligeUrl(u) {
    u = String(u || '');
    return /^(https?:\/\/|\/)/.test(u) ? u : '#';
  }

  /* Overnemen van de serverlijst (bron van waarheid) zonder terug te pushen. */
  function neemServerOver(res) {
    if (res && res.ok && Array.isArray(res.items)) {
      bewaarLokaal(res.items);
      if (herrenderPagina) herrenderPagina();
    }
  }

  function sleutelVan(item) { return item.h + ':' + (item.v || ''); }
  function zitErin(lijst, item) {
    return lijst.some(function (x) { return sleutelVan(x) === sleutelVan(item); });
  }

  /* ── Teller in de header + hartjes markeren ── */
  function meldUpdate(lijst) {
    var n = lijst.length;
    document.querySelectorAll('[data-verlanglijst-teller]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('hdr__teller--leeg', n === 0);
      el.classList.remove('hdr__teller--pop');
      void el.offsetWidth; /* animatie herstarten */
      el.classList.add('hdr__teller--pop');
    });
    markeerHarten(document);
    if (window.Kideo) Kideo.meld('verlanglijst:update', { aantal: n });
  }

  function markeerHarten(wortel) {
    var lijst = lees();
    (wortel.querySelectorAll ? wortel : document)
      .querySelectorAll('[data-hart]').forEach(function (knop) {
        var item = itemUitKnop(knop);
        var bewaard = zitErin(lijst, item);
        knop.classList.toggle('is-bewaard', bewaard);
        knop.setAttribute('aria-pressed', bewaard ? 'true' : 'false');
        knop.setAttribute('aria-label', bewaard ? 'Verwijder van verlanglijst' : 'Bewaar op verlanglijst');
      });
  }

  /* ── Item uit de data-attributen van een hartknop ── */
  function itemUitKnop(knop) {
    var d = knop.dataset;
    var variant = d.variant || '';
    var url = d.url || '';
    /* Op de productpagina volgt het hart de gekozen variant live */
    if (knop.hasAttribute('data-hart-pdp')) {
      var vorm = document.querySelector('[data-product-form] [data-variant-id]');
      if (vorm && vorm.value) {
        variant = vorm.value;
        url = '/products/' + d.handle + '?variant=' + variant;
      }
    }
    return {
      h: d.handle,
      v: variant,
      t: d.titel || '',
      u: url || ('/products/' + d.handle),
      f: d.foto || '',
      p: d.prijs || '',
      o: d.oud || '',
      m: d.merk || ''
    };
  }

  /* ── Klik op een hartje (event delegation: werkt ook op
        kaarten die later via AJAX verschijnen) ── */
  document.addEventListener('click', function (e) {
    var knop = e.target.closest('[data-hart]');
    if (!knop) return;
    e.preventDefault();
    var item = itemUitKnop(knop);
    if (!item.h) return;
    var lijst = lees();
    if (zitErin(lijst, item)) {
      lijst = lijst.filter(function (x) { return sleutelVan(x) !== sleutelVan(item); });
    } else {
      lijst.push(item);
      knop.classList.remove('hart-pop');
      void knop.offsetWidth;
      knop.classList.add('hart-pop');
    }
    schrijf(lijst);
  });

  /* Kaarten die na het laden verschijnen (sliders, drawer) ook markeren */
  var wachter = null;
  new MutationObserver(function () {
    clearTimeout(wachter);
    wachter = setTimeout(function () { markeerHarten(document); }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ── Geldbedrag uit centen (shop-notatie: € 24,95) ── */
  function euro(centen) {
    return '€ ' + (centen / 100).toFixed(2).replace('.', ',');
  }

  /* ── De verlanglijst-pagina ── */
  function initPagina() {
    var houder = document.querySelector('[data-verlanglijst-lijst]');
    if (!houder) return;
    var leeg = document.querySelector('[data-verlanglijst-leeg]');

    function render() {
      var lijst = lees();
      houder.innerHTML = '';
      if (leeg) leeg.hidden = lijst.length > 0;
      houder.hidden = lijst.length === 0;

      lijst.forEach(function (item) {
        var kaart = document.createElement('div');
        kaart.className = 'pkaart kaart kaart--hover vlp__kaart';
        kaart.setAttribute('data-vlp-sleutel', sleutelVan(item));
        kaart.innerHTML =
          '<button type="button" class="vlp__weg" data-vlp-weg aria-label="Verwijder van verlanglijst">' + KRUIS_SVG + '</button>' +
          '<a class="pkaart__foto-link" data-vlp-fotolink tabindex="-1" aria-hidden="true">' +
            '<div class="pkaart__foto"></div>' +
          '</a>' +
          (item.m ? '<div class="pkaart__merkrij"><span class="pkaart__merk"></span></div>' : '') +
          '<a class="pkaart__naam" data-vlp-naamlink></a>' +
          '<div class="pkaart__onder">' +
            '<div class="pkaart__prijsrij">' +
              '<s data-vlp-oud hidden></s>' +
              '<span class="pkaart__prijs" data-vlp-prijs></span>' +
            '</div>' +
            '<span class="pkaart__voorraad" data-vlp-voorraad></span>' +
            '<button type="button" class="ronde-knop" data-vlp-knop aria-label="Actie">' + CART_SVG + '</button>' +
          '</div>';
        /* URL's en afbeelding via attributen — nooit als HTML (geen XSS via
           opgeslagen waarden), en met scheme-check. */
        var veilig = veiligeUrl(item.u);
        kaart.querySelector('[data-vlp-fotolink]').setAttribute('href', veilig);
        kaart.querySelector('[data-vlp-naamlink]').setAttribute('href', veilig);
        if (item.f && veiligeUrl(item.f) !== '#') {
          var foto = document.createElement('img');
          foto.setAttribute('src', item.f);
          foto.setAttribute('alt', '');
          foto.setAttribute('loading', 'lazy');
          kaart.querySelector('.pkaart__foto').appendChild(foto);
        }
        /* tekst veilig zetten (nooit als HTML) */
        if (item.m) kaart.querySelector('.pkaart__merk').textContent = item.m;
        kaart.querySelector('.pkaart__naam').textContent = item.t || item.h;
        kaart.querySelector('[data-vlp-prijs]').textContent = item.p;
        if (item.o) {
          var oud = kaart.querySelector('[data-vlp-oud]');
          oud.textContent = item.o;
          oud.hidden = false;
        }
        houder.appendChild(kaart);
        verversKaart(kaart, item);
      });
    }

    /* Actuele prijs + voorraad + koopknop; product weg → nette melding */
    function verversKaart(kaart, item) {
      var knop = kaart.querySelector('[data-vlp-knop]');
      fetch('/products/' + item.h + '.js')
        .then(function (r) { if (!r.ok) throw new Error('weg'); return r.json(); })
        .then(function (p) {
          var variant = null;
          if (item.v) {
            variant = p.variants.find(function (v) { return String(v.id) === String(item.v); });
          }
          if (!variant) variant = p.variants.find(function (v) { return v.available; }) || p.variants[0];
          if (!variant) throw new Error('weg');

          kaart.querySelector('[data-vlp-prijs]').textContent = euro(variant.price);
          var oud = kaart.querySelector('[data-vlp-oud]');
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            oud.textContent = euro(variant.compare_at_price);
            oud.hidden = false;
          } else { oud.hidden = true; }

          var voorraad = kaart.querySelector('[data-vlp-voorraad]');
          if (variant.available) {
            voorraad.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg> Op voorraad';
            /* specifieke variant óf maar één variant → direct in de mand;
               anders (meerdere kleuren/maten) naar de productpagina om te kiezen */
            if (item.v || p.variants.length === 1) {
              knop.dataset.add = variant.id;
              knop.setAttribute('aria-label', 'In winkelmand');
            } else {
              knop.dataset.href = item.u;
              knop.setAttribute('aria-label', 'Bekijk product');
            }
          } else {
            voorraad.textContent = 'Uitverkocht';
            voorraad.classList.add('pkaart__voorraad--uit');
            knop.classList.add('ronde-knop--uit');
            knop.dataset.href = item.u;
            knop.setAttribute('aria-label', 'Bekijk product');
          }
        })
        .catch(function () {
          var voorraad = kaart.querySelector('[data-vlp-voorraad]');
          voorraad.textContent = 'Niet meer leverbaar';
          voorraad.classList.add('pkaart__voorraad--uit');
          knop.classList.add('ronde-knop--uit');
          knop.dataset.href = item.u;
        });
    }

    /* Verwijderen · in winkelmand · naar product (delegation binnen de lijst) */
    houder.addEventListener('click', function (e) {
      var weg = e.target.closest('[data-vlp-weg]');
      if (weg) {
        var kaart = weg.closest('[data-vlp-sleutel]');
        var sleutel = kaart.getAttribute('data-vlp-sleutel');
        schrijf(lees().filter(function (x) { return sleutelVan(x) !== sleutel; }));
        render();
        return;
      }
      var knop = e.target.closest('[data-vlp-knop]');
      if (!knop) return;
      if (knop.dataset.href && !knop.dataset.add) { window.location.href = knop.dataset.href; return; }
      if (!knop.dataset.add) return;
      knop.disabled = true;
      knop.classList.add('is-bezig');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(knop.dataset.add), quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          if (window.Kideo) Kideo.meld('cart:update', { itemCount: cart.item_count });
          knop.classList.remove('is-bezig');
          knop.classList.add('is-klaar');
          setTimeout(function () { knop.classList.remove('is-klaar'); knop.disabled = false; }, 1600);
        })
        .catch(function () { knop.classList.remove('is-bezig'); knop.disabled = false; });
    });

    herrenderPagina = render;
    render();
  }

  /* zodat de merge-na-inloggen de lijstpagina opnieuw kan tekenen */
  var herrenderPagina = null;

  function init() {
    /* Uitgelogd op dit apparaat (was met een account gesynct, nu gast): de
       accountlijst mag niet blijven staan — anders ziet de volgende (gast of
       andere klant) hem, of merget hij mee in een ander account. Wissen en
       schoon verder als gast. De lijst zelf staat veilig in het klantaccount. */
    if (!ingelogd() && gesyncteKlant()) {
      try { localStorage.removeItem(SLEUTEL); localStorage.removeItem(ACCOUNT_SLEUTEL); } catch (e) { /* */ }
    }
    meldUpdate(lees());
    initPagina();
    if (!ingelogd()) return;
    var huidige = String(window.KIDEO_KLANT);
    var vorige = gesyncteKlant();
    if (vorige === huidige) {
      /* Zelfde account, al eens gesynct: de server is de bron — zo komen ook
         verwijderingen van andere apparaten door. */
      api('GET').then(neemServerOver);
    } else if (!vorige) {
      /* Gast die nu inlogt: de gast-lijst samenvoegen met de accountlijst
         (niets gaat verloren). Pas "gesynct" markeren ná een bevestigd antwoord,
         zodat een mislukte sync het apparaat niet verkeerd brandmerkt. */
      api('POST', { actie: 'merge', items: lees() }).then(function (res) {
        if (res && res.ok) {
          neemServerOver(res);
          zetGesyncteKlant(huidige);
        }
      });
    } else {
      /* Ander account op dit apparaat: NIET mergen (geen lijst van een vorige
         klant lekken) — eerst lokaal leegmaken, dan de eigen accountlijst laden. */
      bewaarLokaal([]);
      api('GET').then(function (res) {
        if (res && res.ok) {
          neemServerOver(res);
          zetGesyncteKlant(huidige);
        }
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
